const formValidation = () => {
    validate.init({
        // Classes and Selectors
        selector: '.js-form-validate',
        fieldClass: 'has-error',
        errorClass: 'form__group__error',

        // Messages
        messageValueMissing: (typeof messages !== 'undefined' && messages.messageValueMissing) ? messages.messageValueMissing : 'Please fill this input',
        messageValueMissingSelect: (typeof messages !== 'undefined' && messages.messageValueMissingSelect) ? messages.messageValueMissingSelect : 'Please select a value',
        messageValueMissingSelectMulti: (typeof messages !== 'undefined' && messages.messageValueMissingSelectMulti) ? messages.messageValueMissingSelectMulti : 'Please select at least one value',
        messageTypeMismatchEmail: (typeof messages !== 'undefined' && messages.messageTypeMismatchEmail) ? messages.messageTypeMismatchEmail : 'Please enter an email address',
        messageTypeMismatchURL: (typeof messages !== 'undefined' && messages.messageTypeMismatchURL) ? messages.messageTypeMismatchURL : 'Please enter a URL',
        messageTooShort: (typeof messages !== 'undefined' && messages.messageTooShort) ? messages.messageTooShort : 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters',
        messageTooLong: (typeof messages !== 'undefined' && messages.messageTooLong) ? messages.messageTooLong : 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters',
        messagePatternMismatch: (typeof messages !== 'undefined' && messages.messagePatternMismatch) ? messages.messagePatternMismatch : 'Please match the requested format',
        messageBadInput: (typeof messages !== 'undefined' && messages.messageBadInput) ? messages.messageBadInput : 'Please enter a number',
        messageStepMismatch: (typeof messages !== 'undefined' && messages.messageStepMismatch) ? messages.messageStepMismatch : 'Please select a valid value',
        messageRangeOverflow: (typeof messages !== 'undefined' && messages.messageRangeOverflow) ? messages.messageRangeOverflow : 'Please select a value that is no more than {max}',
        messageRangeUnderflow: (typeof messages !== 'undefined' && messages.messageRangeUnderflow) ? messages.messageRangeUnderflow : 'Please select a value that is no less than {min}',
        messageGeneric: (typeof messages !== 'undefined' && messages.messageGeneric) ? messages.messageGeneric : 'The value you entered for this field is invalid',

        // Form Submission
        disableSubmit: true,
        onSubmit(form, fields) {
            if (form.elements.PasswordCheck) {
                const errorMessage = form.querySelector('.js-passwordcheck-error');

                if (form.elements.Password.value !== form.elements.PasswordCheck.value) {
                    errorMessage.style.display = 'block';
                    return false;
                }

                errorMessage.style.display = 'none';
            }

            if (form.querySelector('.g-recaptcha') !== null) {
                grecaptcha.reset();
                grecaptcha.execute();

                return false;
            } else if (form.classList.contains('js-ajax-form')) {
                return false;
            } else {

                var btn = document.getElementById("MainFormSubmitButton");
                if (btn != null) {
                    btn.disabled = true;
                }

                form.submit();
            }

            return true;
        },
    });

    const togglePasswordInput = (passwordInput) => {
        if (passwordInput.getAttribute('type') === 'password') {
            passwordInput.setAttribute('type', 'text');
        } else {
            passwordInput.setAttribute('type', 'password');
        }
    };

    const togglePasswordCheckbox = document.querySelectorAll('.js-toggle-password');

    togglePasswordCheckbox.forEach((checkbox) => {
        checkbox.addEventListener('change', (event) => {
            const oPasswordInput = document.querySelector(`input[id="${checkbox.dataset.for}"]`);
            togglePasswordInput(oPasswordInput);
        });
    });
};

const recaptchaValidated = (token) => {
    let aResponseFields = document.querySelectorAll('.g-recaptcha-response');
    let validated = false;
    let oValidatedForm;

    if (aResponseFields.length > 0) {
        for (let i = 0; i < aResponseFields.length; i += 1) {
            if (aResponseFields[i].value === token) {
                validated = true;
                oValidatedForm = aResponseFields[i].closest('.js-form-validate');
                break;
            }
        }

        if (validated && oValidatedForm !== null) {

            var btn = document.getElementById("MainFormSubmitButton");
            if (btn != null) {
                btn.disabled = true;
            }

            oValidatedForm.submit();
        }
    }
};